import styled from "styled-components";
import { COLORS } from "../../../../../../styles/constants.style";

export const ArchiveContractDocumentModalsWrapper = styled.div`
  .container {
    max-height: 290px;
    padding: 24px 16px;
    overflow: auto;
  }
  .separator {
    border-bottom: 1px solid ${COLORS.primary_light_blue4};
    width: 100%;
    &.dashed {
      border-bottom-style: dashed;
    }
  }
  .archive-contract-document-comment {
    display: grid;
    margin-top: 16px;
    .comment-input {
      .MuiInputBase-root {
        height: 100px;
        background: ${COLORS.cirrus_black1};
        padding: 0px;
      }
    }
  }
`;
